import { makeAutoObservable, toJS } from 'mobx'

import { RawTourFlight } from 'shared/api/tours/flights/model'
import { Hotel, Tour } from 'shared/api/tours/search'

export interface SelectedRoomFilters {
  meal_type: string[]
  operators: string[]
  room_types: string[]
}

const initialRoomFilters: SelectedRoomFilters = {
  meal_type: [],
  operators: [],
  room_types: [],
}

class SelectionStore {
  selectedFlight: RawTourFlight | null = null
  selectedHotel: Hotel | null = null
  selectedRoom: Tour | null = null
  selectedRoomFilters: SelectedRoomFilters = initialRoomFilters

  constructor() {
    makeAutoObservable(this)
  }

  setSelectedFlight(flight: RawTourFlight | null) {
    this.selectedFlight = flight
  }

  getSelectedFlight() {
    return toJS(this.selectedFlight)
  }

  setSelectedHotel(hotel: Hotel | null) {
    this.selectedHotel = hotel
  }

  getSelectedHotel() {
    return toJS(this.selectedHotel)
  }

  setSelectedRoom(room: Tour | null) {
    this.selectedRoom = room
  }

  getSelectedRoom() {
    return toJS(this.selectedRoom)
  }

  getRoomFilters() {
    return toJS(this.selectedRoomFilters)
  }

  setRoomFilters(filters: SelectedRoomFilters) {
    this.selectedRoomFilters = filters
  }

  resetRoomFilters() {
    this.selectedRoomFilters = initialRoomFilters
  }
}

export default new SelectionStore()
